export default "__VITE_ASSET__DzdVMFlP__"